import { render, staticRenderFns } from "./OccupantUpdate.vue?vue&type=template&id=0f6317e6&scoped=true"
import script from "./OccupantUpdate.vue?vue&type=script&lang=js"
export * from "./OccupantUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6317e6",
  null
  
)

export default component.exports